export default function navTabs() {
    let tabs = document.querySelector('.section-tabs')

    if (!tabs) {
        return
    }

    let tabsItems = tabs.querySelectorAll('.tabs__nav__item a')
    let tabPanes = tabs.querySelectorAll('.tabs__content__pane')
    let hasActive = false

    tabsItems.forEach(function (el, index) {
        if (el.classList.contains('active')) {
            hasActive = true
        }

        el.addEventListener('click', function (e) {
            e.preventDefault()

            tabsItems.forEach(function (item) {
                item.parentNode.classList.remove('active')
            })
            tabPanes.forEach(function (item) {
                item.classList.remove('active')
            })

            el.parentNode.classList.add('active')
            tabs.querySelector(el.getAttribute('href')).classList.add('active')
        })
    })

    if (!hasActive && tabsItems[0]) {
        tabsItems[0].click()
    }
}
